import { useTranslate } from "ra-core";
import { Badge } from "@/components/ui/badge";
import type { ContractStatus } from "../types";

export const ContractStatusBadge = ({
  status,
}: {
  status?: ContractStatus;
}) => {
  const translate = useTranslate();
  if (!status) return null;

  const variant = status === "overdue" ? "destructive" : "secondary";

  return (
    <Badge variant={variant}>
      {translate(`resources.contracts.statuses.${status}`, { _: status })}
    </Badge>
  );
};
